module.exports = __webpack_public_path__ + "img/cv.c9990d61.jpg";